import React from 'react';
import { Link } from 'react-router-dom';

import Icon from '../../DesignSystem/Icons/Icon';

export const MenuItem = ({ children }) => (
    <li style={{ padding: '0px 5px', margin: '1px 7px', borderRadius: '8px' }}>
        {children}
    </li>
);

export const MenuItemIcon = ({ linkTo, onClick, iconName, size, children }) => {
    const ItemIcon = () => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '24px', height: '24px', background: '#E8EFFF', borderRadius: '8px' }}>
                <Icon name={iconName} size={size} style={{ color: '#265BFF' }} />
            </div>
            {children}
        </div>
    );

    return (
        <MenuItem>
            {linkTo ? (
                <Link to={linkTo} className="no-padding">
                    <ItemIcon />
                </Link>
            ) : (
                <div onClick={onClick}>
                    <ItemIcon />
                </div>
            )}
        </MenuItem>
    )
};